module.exports = __webpack_public_path__ + "img/11.914c9a63.jpg";